import React from 'react';

export const AdminSection = () => (
  <>
    <h3 className="text-lg font-semibold mb-3">System Administration</h3>

    <div className="mb-6">
      <h4 className="font-semibold mb-2">Hospitals Management</h4>
      <p className="text-sm mb-2">Manage hospital information and users:</p>
      <ul className="list-disc list-inside space-y-1 text-sm ml-4">
        <li>Add new hospitals with name and currency</li>
        <li>Create hospital users (Admin, Finance, Reception roles)</li>
        <li>Set temporary passwords for new users</li>
        <li>Users must change password on first login</li>
      </ul>
    </div>

    <div className="mb-6">
      <h4 className="font-semibold mb-2">Families & Members</h4>
      <p className="text-sm mb-2">Manage patient families:</p>
      <ul className="list-disc list-inside space-y-1 text-sm ml-4">
        <li><strong>Create families</strong>: Add family ID, principal member name, and total allotment</li>
        <li><strong>Add members</strong>: Link members to families with serial numbers</li>
        <li><strong>Suspend/Unsuspend</strong>: Control access for families or individual members</li>
        <li><strong>Bulk upload</strong>: Use CSV template to add multiple families at once</li>
      </ul>
      <div className="bg-purple-50 border border-purple-200 rounded p-3 mt-2 text-sm">
        <strong>CSV Format:</strong> Download template from the Families tab. Include: family_id, principle_member_name, total_allotment, remaining_balance
      </div>
    </div>

    <div className="mb-6">
      <h4 className="font-semibold mb-2">Price Lists</h4>
      <p className="text-sm mb-2">Configure medical service pricing:</p>
      <ul className="list-disc list-inside space-y-1 text-sm ml-4">
        <li>Each hospital has its own price list</li>
        <li>Add items with: Item ID, Name, Type, and Cost</li>
        <li>Cost is in hospital's local currency</li>
        <li><strong>Bulk upload</strong>: Use CSV template for multiple items</li>
      </ul>
      <div className="bg-purple-50 border border-purple-200 rounded p-3 mt-2 text-sm">
        <strong>CSV Format:</strong> Download template from Price Lists tab. Include: item_id, item_name, item_type, cost
      </div>
    </div>

    <div className="mb-6">
      <h4 className="font-semibold mb-2">Deposits Management</h4>
      <p className="text-sm mb-2">Add funds to hospital accounts:</p>
      <ul className="list-disc list-inside space-y-1 text-sm ml-4">
        <li>Select hospital from dropdown</li>
        <li>Enter deposit amount (always in USD)</li>
        <li>View current balance before adding</li>
        <li>Deposits increase hospital's available balance</li>
      </ul>
    </div>

    <div>
      <h4 className="font-semibold mb-2">Activity Logs</h4>
      <p className="text-sm">Monitor system activity on the main dashboard. Logs include:</p>
      <ul className="list-disc list-inside space-y-1 text-sm ml-4">
        <li>User logins</li>
        <li>Claim submissions</li>
        <li>Deposit additions</li>
        <li>Timestamp and user details</li>
      </ul>
    </div>
  </>
);
